import { TFunction } from 'i18next';
import { OverviewData } from './Overview.types';
import { AdDetails } from '@/api/types/ads.types';
import { getMessageTime } from '@/utils/datetime.utils';

export const getOverviewData = (
  t: TFunction,
  adDetails: AdDetails
): OverviewData[] => {
  const { legacyResourceId, hits, updatedAt } = adDetails;
  return [
    { id: 1, name: t('pages.ad.ad_number'), value: legacyResourceId },
    { id: 2, name: t('pages.ad.views'), value: hits },
    {
      id: 3,
      name: t('pages.ad.updated'),
      value: getMessageTime(new Date(updatedAt), t, true),
    },
  ];
};
